// src/components/shared/EinzelfotoThumbnail.jsx
// Kleine Vorschau für die Mobilansicht bei einseitigen Rechnungen (ein einzelnes Foto) -
// ersetzt dort die große Desktop-Vorschauspalte (siehe RechnungTab.jsx: zeigeEinzelfotoThumbnail).
// Der Benutzer hat das Dokument beim Fotografieren ohnehin physisch vor sich, die große
// Vorschau nimmt auf dem kleinen Bildschirm nur Platz weg. Optisch an .multi-photo-thumb
// angelehnt (gleiche CSS-Klassen wie MultiImageCapture), damit es sich wie eine "Seite 1 von 1"
// der Mehrseiten-Vorschau einfügt - an genau der Stelle, an der bei mehreren Fotos auch die
// Thumbnail-Reihe erscheint.
import React, { useEffect, useState } from 'react'

function EinzelfotoThumbnail ({ file }) {
  const [previewUrl, setPreviewUrl] = useState(null)

  useEffect(() => {
    if (!file) {
      setPreviewUrl(null)
      return undefined
    }
    const url = URL.createObjectURL(file)
    setPreviewUrl(url)
    return () => URL.revokeObjectURL(url)
  }, [file])

  if (!file || !previewUrl) return null

  const extension = file.name.split('.').pop()?.toLowerCase()
  const isImage =
    file.type.startsWith('image/') ||
    ['png', 'jpg', 'jpeg', 'bmp'].includes(extension)

  // Kamera-Aufnahmen sind immer Bilder - ein PDF landet hier praktisch nie (Mobilansicht
  // bietet ja nur noch "Fotografieren" an, siehe FileSelectButton-Ausblendung). Falls doch,
  // lieber gar keine Vorschau als eine falsche.
  if (!isImage) return null

  return (
    <div className='multi-photo-thumbs'>
      <div className='multi-photo-thumb'>
        <img src={previewUrl} alt={file.name} />
      </div>
    </div>
  )
}

export default EinzelfotoThumbnail
